module.exports = __webpack_public_path__ + "static/thumbtack-square.288852f4.jpg";